import { useLocation } from "react-router-dom";
import DesktopBudgetHeader from "./DesktopBudgetHeader";
import BudgetModuleYearCard from "./BudgetModuleYearCard";
import { useEffect } from "react";
import { APP_NAME } from "../constants/app";
import { saveSelectedBudgetModulePage } from "../utils/budgetFlow";

const BudgetModulePageShell = ({
  title,
  description,
  yearCards,
  selectedYear,
  onSelectYear,
  children,
}) => {
  const location = useLocation();
  const displayYearCards =
    yearCards.length > 0
      ? yearCards
      : selectedYear
        ? [{ financial_year: selectedYear }]
        : [];

  useEffect(() => {
    saveSelectedBudgetModulePage(location.pathname);
  }, [location.pathname]);

  return (
    <section className="base-data-layout budget-web-layout">
      <DesktopBudgetHeader />

      <p className="page-title-text">
        {APP_NAME} <strong>{title}</strong>
      </p>

      {description ? <p className="budget-module-heading__copy">{description}</p> : null}

      {displayYearCards.length > 0 ? (
        <div className="base-data-cardContainer budget-module-yearCards">
          {displayYearCards.map((card) => (
            <BudgetModuleYearCard
              key={card.financial_year}
              title={card.financial_year}
              isSelected={selectedYear === card.financial_year}
              onClick={() => onSelectYear(card.financial_year)}
            />
          ))}
        </div>
      ) : null}

      <div className="base-data-dataTable budget-web-dataTable">{children}</div>
    </section>
  );
};

export default BudgetModulePageShell;
